import React, { useRef, useState } from 'react';
import { useMediaAttachment } from '../../../hooks/useMediaAttachment';
import { MediaOverlay } from './MediaOverlay';
import MediaModal from "../../../../../Components/MediaModal";
import { WhatsappMessage } from '../../../types/whatsapp';

interface VideoAttachmentProps {
    mediaId: string;
    caption?: string;
    messages?: WhatsappMessage[];
    currentMessageId?: string;
    getMediaUrl?: (mediaId: string, type: string) => Promise<string>;
}

export const VideoAttachment = ({ mediaId, caption, messages, currentMessageId, getMediaUrl }: VideoAttachmentProps) => {
    const { url, status, downloadMedia } = useMediaAttachment(mediaId);
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const canOpen = status === 'SUCCESS' && !!url;
    const openModal = () => {
        if (!canOpen) return;
        // Pausa el video pequeño del chat al abrir el modal
        try { videoRef.current?.pause(); } catch {}
        setIsModalOpen(true);
    };
    const toggleModal = () => setIsModalOpen(v => !v);

    return (
        <div className="d-flex flex-column gap-1">
            <div
                className="position-relative bg-dark rounded"
                style={{ minWidth: '220px', minHeight: '150px', overflow: 'hidden', cursor: canOpen ? 'pointer' : 'default' }}
                onClick={openModal}
            >
                <MediaOverlay status={status} typeLabel="Video" icon={<i className="ri-video-line"></i>} onClick={downloadMedia} />
                {url && status === 'SUCCESS' && (
                    <video ref={videoRef} src={url} controls className="w-100" style={{ maxHeight: '300px' }} controlsList="nodownload" />
                )}
            </div>
            {caption && <div className="text-break" style={{ whiteSpace: 'pre-wrap' }}>{caption}</div>}

            {/* Usa el componente MediaModal para el video ampliado */}
            {messages && currentMessageId && getMediaUrl ? (
                <MediaModal
                    isOpen={isModalOpen}
                    toggle={toggleModal}
                    messages={messages}
                    initialMessageId={currentMessageId}
                    getMediaUrl={getMediaUrl}
                />
            ) : (
                <MediaModal
                    isOpen={isModalOpen}
                    toggle={toggleModal}
                    messages={[]}
                    initialMessageId={null}
                    getMediaUrl={async (id) => url || ''}
                />
            )}
        </div>
    );
};
